import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectRiskPlanMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_RISK_PLAN_MESSAGE);
        this.Id = 0;
        this.Description = null;
        this.Name = null;
        this.Data = [];
    }
}
